import axiosClient from '../../configs/axios.js';

class ProductionQuantityReportService {
  async getSummary({ start_date, end_date }) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('start_date', start_date);
      queryParams.append('end_date', end_date);

      const response = await axiosClient.get(
        `/reports/ProductionQuantitySummary?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ProductionQuantityReportService();